// Customer utility functions

export const generateCustomerCode = (customerNumber: number): string => {
  const paddedNumber = String(customerNumber).padStart(4, '0');
  return `SNS/CLIENT/${paddedNumber}`;
};

export const getNextCustomerNumber = (existingCustomers: any[]): number => {
  if (existingCustomers.length === 0) {
    return 20260001;
  }
  
  // Extract the last number from the last customer code
  const lastCustomer = existingCustomers[existingCustomers.length - 1];
  const lastCode = lastCustomer.kodPelanggan;
  
  // Parse the number from SNS/CLIENT/XXXX format
  const lastNumber = parseInt(lastCode.split('/')[2]);
  return lastNumber + 1;
};

export const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const getInitialsColor = (initials: string): string => {
  const colors = [
    'bg-red-100 text-red-700',
    'bg-blue-100 text-blue-700',
    'bg-green-100 text-green-700',
    'bg-yellow-100 text-yellow-700',
    'bg-purple-100 text-purple-700',
    'bg-pink-100 text-pink-700',
    'bg-indigo-100 text-indigo-700',
    'bg-orange-100 text-orange-700',
  ];
  
  const charCode = initials.charCodeAt(0);
  return colors[charCode % colors.length];
};
